import { Cache } from "memory-cache";
import { CloneEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCloneEntity(character_id: number): Promise<CloneEntity | null> {
  let entity: any = await cache.get(character_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCloneEntity(clones: CloneEntity) {
  cache.put(clones.props._character_id, clones, 60 * 60 * 1000 /* 1 hour */);
}
